module.exports = __webpack_public_path__ + "img/blackjack.3cb71fb6.jpeg";